import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCreative, Navigation, Pagination, Autoplay } from 'swiper/modules';
import { X } from 'lucide-react';

import 'swiper/css';
import 'swiper/css/effect-creative';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const HeroCarousel = ({imgs}) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (imgs && Array.isArray(imgs)) {
      const filteredImgs = imgs.filter((img) => {
        return typeof img === 'string' && (
          img.endsWith('.jpg') ||
          img.endsWith('.jpeg') ||
          img.endsWith('.png') ||
          img.endsWith('.gif') ||
          img.endsWith('.webp')
        );
      });
      setImages(filteredImgs);
    }
  }, [imgs]);

  return (
    <div className="absolute h-full w-full bg-black/90">

      <Swiper
        effect={'creative'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        creativeEffect={{
          prev: {
            translate: ['-100%', 0, 0],
          },
          next: {
            translate: ['100%', 0, 0],
          },
          limitProgress: 3,
        }}
        navigation={false}
        pagination={false}
        modules={[EffectCreative, Navigation, Pagination, Autoplay]}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        
        className="wave-swiper h-full w-full"
      >
        {images.map((src, index) => (
          <SwiperSlide key={index} className="bg-transparent">
            <img 
                src={src} 
                alt={`Image ${index + 1}`} 
                className="object-cover w-full h-full"
              />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroCarousel;